


















































































































































































































import {Vue, Component} from 'vue-property-decorator';
import GenericButton from '@/components/GenericButton.vue';
import AccOrgAutocomplete from '@/components/AccOrgAutocomplete.vue';
import {Action, Getter} from 'vuex-class';
import {
  AccountSubscriptionOrder, CommercialAccount,
  ConsolidatedSubscriptionOrder, IDataTableHeader,
  SimCard,
  SubscriptionOrder,
  SubscriptionProduct,
} from '@/types';
import { copyToClipboard } from '@/classes/utils';
import SubscriptionsService from '@/services/subscriptions.service';
import AccountService from '@/services/account.service';
import BarcodeScanner from '@/components/BarcodeScanner.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import {isActivateByPassed} from '@/helpers/subscription';
import AddSubscriptionOrderForm from '@/components/subscriptions/AddSubscriptionOrderForm.vue';
import Dialog from '@/components/Dialog.vue';
import Table from '@/components/Table.vue';
import ActionBarButton from '@/components/ActionBarButton.vue';
import SearchBar from '@/components/SearchBar.vue';
import Transformation from '@/classes/transformation';
import MultiOrgSubscriptionOrder from '@/components/subscriptions/MultiOrgSubscriptionOrder.vue';

@Component({
  components: {
    MultiOrgSubscriptionOrder,
    SearchBar,
    ActionBarButton,
    Table,
    Dialog,
    AddSubscriptionOrderForm,
    ConfirmButton,
    CancelButton,
    BarcodeScanner,
    AccOrgAutocomplete, GenericButton},
})
export default class AccountSubscriptionOrders extends Vue {
  @Action private clearToastErrorMessages: any;
  @Getter private hasPermission: any;
  @Getter private organisations: any;
  @Getter private activeAccountId: any;
  @Getter private activeAccount: any;
  private subscriptionOrders: ConsolidatedSubscriptionOrder[] = [];
  private subscriptionProducts: SubscriptionProduct[] = [];
  private simsForOrder: SimCard[] = [];
  private account: CommercialAccount | null = null;

  private showAllocationDialog: boolean = false;

  private editing: boolean = true;
  private selectedSubscriptionOrder: ConsolidatedSubscriptionOrder | null = null;
  private showAddEditDialog: boolean = false;

  private itemsPerPage: number = 100;
  private perPage: number = 100;
  private page: number = 1;

  private expanded: any = [];
  private singleExpand: boolean = true;
  private showInactive: boolean = true;

  private searchName: string = '';

  private loading: boolean = true;

  private queryData: any = { sort: ['subscription_product.name', 'suborder.activate_by'] };
  private simHeaders: any[] = [
    {text: 'ICCID', value: 'iccid', width: '19%'},
    {text: '', value: 'type', width: '5%', align: 'center'},
    {text: 'Identifier', value: 'identifier'},
    {text: 'Organisation', value: 'organisation'},
    {text: 'Subscription', value: 'subscription'},
  ];
  private tableData: any = {
    headers: [
      {
        text: 'Order reference',
        value: 'orderNumber',
        align: 'start',
        filterable: false,
        sortable: true,
        querySortKey: 'suborder.order_number',
      },
      {
        text: 'Subscription product',
        value: 'subscriptionProductName',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'subscriptionProducts',
        querySortKey: 'subscription_product.name',
      },
      {
        text: 'Organisation',
        value: 'organisation',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'organisations',
        querySortKey: 'organisation.name',
      },
      {
        text: 'Activate by',
        value: 'activateBy',
        align: 'start',
        filterable: false,
        sortable: true,
        querySortKey: 'suborder.activate_by',
      },
      {
        text: 'Term length',
        value: 'termLength',
        align: 'start',
        filterable: true,
        sortable: true,
        queryKey: 'termLength',
        querySortKey: 'subscription_product.term_length',
      },
      {
        text: 'Available',
        value: 'availableSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'availableSubscriptions',
        tooltipText: 'Not yet activated',
      },
      {
        text: 'Active',
        value: 'activeSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'activeSubscriptions',
        tooltipText: 'Currently active',
      },
      {
        text: 'Detached',
        value: 'detachedSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'detachedSubscriptions',
        tooltipText: 'Activated but not linked to a device',
      },
      {
        text: 'Lapsed',
        value: 'lapsedSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'lapsedSubscriptions',
        tooltipText: 'Not activated but past activation date',
      },
      {
        text: 'Not renewing',
        value: 'notRenewingSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'notRenewingSubscriptions',
        tooltipText: 'Will not auto renew',
      },
      {
        text: 'Expired',
        value: 'expiredSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'expiredSubscriptions',
        tooltipText: 'Activated but past expiration date',
      },
      {
        text: 'Unallocated',
        value: 'unallocatedSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        tooltipText: 'Unallocated subscriptions in this order',
      },
      {
        text: 'Total',
        value: 'totalSubscriptions',
        align: 'start',
        filterable: false,
        sortable: false,
        querySortKey: 'totalSubscriptions',
        tooltipText: 'Total subscriptions for this order',
      },
      {
        text: '',
        value: 'actions',
        class: 'sticky-column',
        filterable: false,
        sortable: false,
      },
    ],
  };

  private async mounted() {
    await this.loadAccount();
    await this.loadData();
  }

  private async loadAccount() {
    Vue.set(this, 'account', this.activeAccount[0]);
  }

  private async loadProducts() {
    const orderIds = this.subscriptionOrders.map((order) => order.id);
    if (!orderIds || !orderIds.length) {
      return;
    }
    const products = await AccountService.getAccountSubscriptionProducts(this.activeAccountId, orderIds);
    Vue.set(this, 'subscriptionProducts', products);
  }

  private async loadData(
      queryData: {
        take?: number;
        skip?: number;
        sort?: string | string[];
        desc?: boolean;
        filters?: { [key: string]: any }; } = this.queryData,
      search: string = this.searchName) {
    this.loading = true;
    if (!queryData.sort) {
      queryData = { ...queryData, sort: ['subscription_product.name', 'suborder.activate_by'] };
    }
    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(queryData.filters);
    const take = !queryData.take || queryData.take === 0 ? this.perPage : queryData.take;

    try {
      const {
        subscriptionOrders,
        total,
        columnFilters,
      }: any = await AccountService.getAccountSubscriptionOrders(this.activeAccountId, !this.showInactive, take, queryData.skip, queryData.sort, queryData.desc, mappedFilters, search);
      Vue.set(this, 'subscriptionOrders', subscriptionOrders);
      this.tableData.total = total;

      Transformation.setTableFilterValues(this.tableData.headers, columnFilters);

      await this.loadProducts();
      await this.formatSubscriptionOrders();
    } finally {
      this.loading = false;
    }
  }

  private async loadSims(selected: SubscriptionOrder) {
    let sims = await AccountService.getSimsForAccountSubscriptionOrder(this.activeAccountId, selected.id);
    sims = sims.map((s: any) => {
      s.identifier = s.device_id || s.gateway_id;
      return s;
    });
    Vue.set(this, 'simsForOrder', sims);
  }

  private async formatSubscriptionOrders() {
    const rows: any[] = [];
    this.subscriptionOrders.forEach((row: any, index: number) => {
      let totalAllocated = 0;
      if (row && row.allocations) {
        for (const org of row.allocations) {
          totalAllocated += Number(org.allocatedSubscriptions) || 0;
        }
      }
      const unallocated = Number(row.totalSubscriptions) - totalAllocated;
      rows.push({
        ...row,
        index,
        subscriptionProductName: row.subscriptionProduct!.name,
        termLength: row.subscriptionProduct!.term_length,
        currency: row.currency,
        remainingSubscriptions: isActivateByPassed(row.activateBy) ? '' : row.totalSubscriptions - row.activeSubscriptions,
        unallocatedSubscriptions: unallocated,
      });
    });
    Vue.set(this.tableData, 'rows', rows);
  }

  private async handleRowClicked(row: any) {
    this.selectedSubscriptionOrder = this.subscriptionOrders[row.index];
    this.editing = true;
    this.showAddEditDialog = true;
  }

  private filterSubscriptionsTable(row: SubscriptionOrder) {
    this.$router.push({name: 'account-subs', params: { subscriptionOrderId: row.id.toString() }});
  }

  private async onQueryDataUpdate(data: object) {
    this.queryData = data;
    await this.loadData(data);
  }

  private async search(search: string) {
    this.searchName = search;
    this.page = 1;

    await this.$nextTick();
    await this.loadData();
  }

  private get filteredOrders() {
    return this.tableData.rows;
  }

  private get orderHeaders() {
    if (this.subscriptionOrders.every((o) => o.isManyToMany)) {
      return this.tableData.headers.filter((h: IDataTableHeader) => h.value !== 'organisation');
    }
    return this.tableData.headers;
  }

  private get allocationHeaders() {
    if (this.subscriptionOrders.every((o) => o.isManyToMany)) {
      return [
        { text: '', value: 'space', sortable: false, width: '56px' },
        { text: 'Organisation', value: 'organisationName', sortable: false, width: '20%' },
        { text: 'Allocated subscriptions', value: 'allocatedSubscriptions', sortable: false, width: '20%'  },
        { text: 'Activated subscriptions', value: 'consumedSubscriptions', sortable: false  },
      ];
    }
    return [
      { text: '', value: 'space', sortable: false, width: '56px'  },
      { text: 'Organisation', value: 'organisationName', sortable: false, width: '20%'  },
      { text: 'Allocated subscriptions', value: 'allocatedSubscriptions', sortable: false  },
    ];
  }
}
